<template>
    <div
        class="related-blogs mx-4 mb-10 mt-20 text-center lg:mx-10 lg:mb-[140px] lg:max-w-[1424px] 2xl:mx-auto"
        v-if="blogs">
        <div class="mb-10 flex flex-col items-center justify-center text-center lg:mb-40 lg:gap-y-10">
            <h2>{{ snippets['headless.relatedBlogs.title'] }}</h2>
            <p class="w-full max-w-[466px] pb-4 pt-3 lg:pb-0 lg:pt-0">
                {{ snippets['headless.relatedBlogs.description'] }}
            </p>
            <NuxtLink
                :to="snippets['headless.footer.blogsOverviewUrl']"
                class="btn btn-primary mx-auto hidden w-fit lg:block">
                {{ snippets['headless.relatedBlogs.buttontext'] }}
            </NuxtLink>
        </div>
        <div class="grid grid-cols-2 gap-6 lg:grid-cols-3 lg:gap-x-8">
            <div
                v-for="blog in blogs"
                :key="blog.versionId"
                class="relative h-[230px] md:h-[350px] xl:h-[400px] 2xl:h-[521px]">
                <NuxtLink :to="formatedSeoUrl(blog.customFields.seoUrl)" class="group">
                    <ShopwareImg
                        v-if="blog.media"
                        :src="blog.media.url"
                        :alt="blog.translated.name"
                        class="blog-overview-image h-full w-full max-w-full object-cover"
                        id="blog-overview-image"
                        :width="400"
                        sizes="100vw sm:50vw md:400px" />

                    <div class="absolute bottom-[24px] left-1/2 w-full -translate-x-1/2 text-white lg:bottom-[80px]">
                        <p
                            v-if="blog.translated.name"
                            class="font-monument-extended text-sm duration-300 group-hover:text-green-600 lg:text-lg">
                            {{ blog.translated.name }}
                        </p>
                        <p
                            v-if="blog.translated.shortDescription"
                            class="w-full font-mori text-sm font-light duration-300 group-hover:text-green-600">
                            {{ formattedDescription(blog.translated.shortDescription) }}
                        </p>
                        <button
                            class="mx-auto hidden border-b-2 text-center font-mori text-sm duration-300 hover:border-green-600 hover:text-green-600 group-hover:border-green-600 group-hover:text-green-600 lg:block">
                            Lees meer
                        </button>
                    </div>
                </NuxtLink>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    const snippetsStore = useSnippetsStore();
    const snippets = snippetsStore.snippets;

    const props = defineProps({
        blogs: Array,
    });
    const isMobile = ref(false);

    onMounted(() => {
        isMobile.value = window.innerWidth <= 768;
    });

    const formattedDescription = (description: string) => {
        if (!description) return '';
        if (isMobile.value) {
            const parts = description.split('-');
            return parts.length > 1 ? parts[1].trim() : description;
        }
        return description;
    };

    const formatedSeoUrl = (url: string) => {
        if (!url) return '';
        const seoUrl = url.split('/');
        return 'blog/' + seoUrl[seoUrl.length - 1];
    };
</script>
